import axios from "axios";

export const fetchModules = async () => {
  try {
    const response = await axios.get("http://localhost:8080/webnet-hms/api/modules/");
    const rawData = response.data.data;
    const flatData = rawData.flat();
    return flatData;
  } catch (error) {
    console.error("Error fetching modules:", error);
    return [];
  }
};
export const fetchModule1 = async (id) => {
  try {
    const response = await axios.get(`http://localhost:8080/webnet-hms/api/modules/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching modules:", error);
    return [];
  }
};
